<template>
  <div class="gift-box__header">
    <AccountIconWh24 :image-url="senderIcon" />
    <div class="gift-box__suffix-message">
      <a
        class="gift-box__sender-name body-bold"
        :class="
          showUsableProfileLink
            ? 'gift-box__sender-name--link'
            : 'gift-box__sender-name--no-link'
        "
        :href="showUsableProfileLink ? createdUserProfilePath : null"
      >
        {{ senderName }}
      </a>
      <div class="gift-box__suffix module-text">さんより</div>
    </div>
  </div>
</template>

<script>
import AccountIconWh24 from '../../atoms/account_icons/AccountIconWh24.vue'
export default {
  components: { AccountIconWh24 },
  props: {
    senderIcon: {
      type: String,
      require: true,
      default: ''
    },
    senderName: {
      type: String,
      require: true,
      default: ''
    },
    showUsableProfileLink: {
      type: Boolean,
      required: false,
      default: false
    },
    createdUserProfilePath: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
<style lang="scss" scoped>
.gift-box {
  &__header {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
  }

  &__suffix-message {
    margin-left: 8px;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__sender-name {
    color: $black;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;

    &--link {
      color: $link;
    }

    &--no-link {
      color: $black;
      pointer-events: none;
    }
  }

  &__suffix {
    flex-shrink: 0;
  }
}
</style>
